<mat-basic-chip
  [aionzPurchaseStatus]="status()"
  [attr.status]="status()"
  class="status-chip">
  <div class="flex-row items-center gap-2 justify-center">
    @if (icon) {
      <mat-icon class="status-chip-icon mr-1">{{ icon }}</mat-icon>
    }
    <span>
      {{ displayLabel() }}
    </span>
  </div>
</mat-basic-chip>
